import { useSelector as reduxUseSelector } from 'react-redux';
import { StoreState } from './store-state';

// Application specific strongly typed wrapper around redux's useSelector().
export function useStateSelector<T>(fn: (state: StoreState) => T): T {
    return reduxUseSelector(fn);
}
